<div class="titlebar">
  <h3>{{ "Template.PdfCatalogsComponent.subHeader_pdfCatalogs" | translate }}</h3>

  <div class="buttons">
    <button class="btn btn-secondary" [disabled]="loadingPdfCatalogs" (click)="refreshPdfCatalogs()">
      <fa-icon icon="arrow-rotate-right"></fa-icon>
    </button>
  </div>
</div>

<form (ngSubmit)="postFile()" [formGroup]="uploadForm" novalidate>
  <div class="row">
    <div class="col-12 col-md-8 col-lg-6">
      <div class="mt-2">
        <label class="fw-bold" for="formFile">{{ "Template.PdfCatalogsComponent.label_controlFile" | translate }}</label>
        <input #formFile class="form-control" type="file" id="formFile" accept=".xlsx" (change)="onFileSelected($event)" [disabled]="fileUploading" />
      </div>

      <div class="mt-4">
        <label class="fw-bold" for="">{{ "Template.PdfCatalogsComponent.label_relationsDescription" | translate }}:</label>
        <div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" formControlName="relations_description" id="relations_description_show" value="show" />
            <label class="form-check-label" for="relations_description_show"> {{ "Template.PdfCatalogsComponent.label_show" | translate }} </label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" formControlName="relations_description" id="relations_description_hide" value="hide" />
            <label class="form-check-label" for="relations_description_hide"> {{ "Template.PdfCatalogsComponent.label_hide" | translate }} </label>
          </div>
        </div>
      </div>

      <div class="mt-2">
        <label class="fw-bold" for="">{{ "Template.PdfCatalogsComponent.label_keywordSource" | translate }}:</label>
        <div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" formControlName="keyword_source" id="keyword_source_schlagwort" value="schlagwort" />
            <label class="form-check-label" for="keyword_source_schlagwort"> {{ "Template.PdfCatalogsComponent.label_keywordSourceKeyword" | translate }} </label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" formControlName="keyword_source" id="keyword_source_cm_bez4" value="cm_bez4" />
            <label class="form-check-label" for="keyword_source_cm_bez4"> {{ "Template.PdfCatalogsComponent.label_keywordSourceCmBez4" | translate }} </label>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <label class="fw-bold" for="">{{ "Template.PdfCatalogsComponent.label_pageKeywords" | translate }}:</label>
        <div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" formControlName="page_keywords" id="page_keywords_show" value="show" />
            <label class="form-check-label" for="page_keywords_show"> {{ "Template.PdfCatalogsComponent.label_show" | translate }} </label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" formControlName="page_keywords" id="page_keywords_hide" value="hide" />
            <label class="form-check-label" for="page_keywords_hide"> {{ "Template.PdfCatalogsComponent.label_hide" | translate }} </label>
          </div>
        </div>
      </div>

      <button type="submit" class="btn btn-secondary d-block w-100 mt-2" [disabled]="!file || fileUploading">{{ "Template.PdfCatalogsComponent.btn_upload" | translate }}</button>
    </div>
  </div>
</form>

<hr class="my-5" />

<div>
  <h5>{{ "Template.PdfCatalogsComponent.subHeader_createdPdfCatalogs" | translate }}</h5>

  @if (loadingPdfCatalogs) {
    <div class="text-center">
      <fa-icon icon="spinner" animation="spin" size="2x"></fa-icon>
    </div>
  }

  @if (!loadingPdfCatalogs && pdfCatalogs.length > 0) {
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">{{ "Template.PdfCatalogsComponent.label_date" | translate }}</th>
          <th scope="col">{{ "Template.PdfCatalogsComponent.label_status" | translate }}</th>
          <th scope="col">{{ "Template.PdfCatalogsComponent.label_editor" | translate }}</th>
          <th scope="col">&nbsp;</th>
          <th scope="col">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        @for (pdfCatalog of pdfCatalogs; track pdfCatalog) {
          <tr>
            <td class="align-middle text-nowrap">{{ "Template.PdfCatalogsComponent.text_dateTime" | translate : { dateTime: pdfCatalog.importDate | date : "d. MMMM yyyy, H:mm" } }}</td>
            <td class="align-middle text-nowrap" [class]="{ 'table-danger': pdfCatalog.status == 'INVALID' || pdfCatalog.status == 'FAILED' }">
              @if (pdfCatalog.status == 'UPLOADED') {
                <span>{{ "Template.PdfCatalogsComponent.text_statusUploaded" | translate }}</span>
              }
              @if (pdfCatalog.status == 'INVALID') {
                <span>{{ "Template.PdfCatalogsComponent.text_statusInvalid" | translate }}</span>
              }
              @if (pdfCatalog.status == 'RENDERING') {
                <span>
                  {{ "Template.PdfCatalogsComponent.text_statusRendering" | translate }}
                  @if (pdfCatalog?.progress! > 0) {
                    <span>({{ pdfCatalog?.progress || 0 }}%)</span>
                  }
                </span>
              }
              @if (pdfCatalog.status == 'FAILED') {
                <span>{{ "Template.PdfCatalogsComponent.text_statusFailed" | translate }}</span>
              }
              @if (pdfCatalog.status == 'READY') {
                <span>{{ "Template.PdfCatalogsComponent.text_statusReady" | translate }}</span>
              }
              @if (pdfCatalog?.messages?.length! > 0) {
                <button role="button" class="btn btn-link p-0 ms-2" (click)="showMessages(pdfMessagesModal)">
                  <fa-icon icon="info-circle" class="text-primary ms-1"></fa-icon>
                </button>
              }
              @if (pdfCatalog?.status == 'RENDERING') {
                <ngb-progressbar type="success" [value]="pdfCatalog?.progress || 0" [animated]="true"></ngb-progressbar>
              }
              <ng-template #pdfMessagesModal let-modal>
                <div class="modal-header">
                  <h5 class="modal-title">{{ "Template.PdfCatalogsComponent.subHeader_generatePdfCatalog" | translate }}</h5>
                  <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
                </div>
                <div class="modal-body">
                  <p>{{ "Template.PdfCatalogsComponent.text_errorsOccurred" | translate }}</p>
                  <ul>
                    @for (error of pdfCatalog.messages; track error) {
                      <li>{{ error }}</li>
                    }
                  </ul>
                </div>
              </ng-template>
            </td>
            <td class="align-middle">
              @if (pdfCatalog.user) {
                <span> {{ pdfCatalog.user.firstname }} {{ pdfCatalog.user.lastname }} </span>
              }
            </td>
            <td class="align-middle text-nowrap text-end">
              @if (pdfCatalog.sourceUrl) {
                <a class="btn btn-secondary btn-sm d-block" [href]="pdfCatalog.sourceUrl" target="_blank">
                  <fa-icon icon="file-excel" class="me-1"></fa-icon>
                  {{ "Template.PdfCatalogsComponent.btn_controlFile" | translate }}
                </a>
              }
            </td>
            <td class="align-middle text-nowrap text-end">
              @if (pdfCatalog.destinationUrl) {
                <a class="btn btn-primary btn-sm d-block" [href]="pdfCatalog.destinationUrl" target="_blank">
                  <fa-icon icon="file-pdf" class="me-1"></fa-icon>
                  {{ "Template.PdfCatalogsComponent.btn_pdfCatalog" | translate }}
                </a>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (!loadingPdfCatalogs && pdfCatalogs.length == 0) {
    <p>{{ "Template.PdfCatalogsComponent.text_noPdfCatalogs" | translate }}</p>
  }
</div>

<hr class="my-5" />

<div>
  <h5 class="mb-3">{{ "Template.PdfCatalogsComponent.subHeader_excelContents" | translate }}:</h5>
  <div class="row ps-4">
    <div class="col">
      <strong class="d-block">{{ "Template.PdfCatalogsComponent.subHeader_firstSheet" | translate }}:</strong>
      <ul class="mb-3">
        <li><strong>{{ "Template.PdfCatalogsComponent.label_column" | translate : { column: "A" } }}: </strong>{{ "Template.PdfCatalogsComponent.text_itemNumber" | translate }}</li>
        <li><strong>{{ "Template.PdfCatalogsComponent.label_column" | translate : { column: "B" } }}: </strong>{{ "Template.PdfCatalogsComponent.text_itemDescription" | translate }}</li>
        <li><strong>{{ "Template.PdfCatalogsComponent.label_column" | translate : { column: "D" } }}: </strong>{{ "Template.PdfCatalogsComponent.text_ekPrice" | translate }}</li>
        <li><strong>{{ "Template.PdfCatalogsComponent.label_column" | translate : { column: "E" } }}: </strong>{{ "Template.PdfCatalogsComponent.text_lvpH" | translate }}</li>
        <li><strong>{{ "Template.PdfCatalogsComponent.label_column" | translate : { column: "F" } }}: </strong>{{ "Template.PdfCatalogsComponent.text_tierQuantity" | translate : { tier: 1 } }}</li>
        <li><strong>{{ "Template.PdfCatalogsComponent.label_column" | translate : { column: "G" } }}: </strong>{{ "Template.PdfCatalogsComponent.text_tierPrice" | translate : { tier: 1 } }}</li>
        <li><strong>{{ "Template.PdfCatalogsComponent.label_column" | translate : { column: "H" } }}: </strong>{{ "Template.PdfCatalogsComponent.text_tierQuantity" | translate : { tier: 2 } }}</li>
        <li><strong>{{ "Template.PdfCatalogsComponent.label_column" | translate : { column: "I" } }}: </strong>{{ "Template.PdfCatalogsComponent.text_tierPrice" | translate : { tier: 2 } }}</li>
        <li><strong>{{ "Template.PdfCatalogsComponent.label_column" | translate : { column: "J" } }}: </strong>{{ "Template.PdfCatalogsComponent.text_tierQuantity" | translate : { tier: 3 } }}</li>
        <li><strong>{{ "Template.PdfCatalogsComponent.label_column" | translate : { column: "K" } }}: </strong>{{ "Template.PdfCatalogsComponent.text_tierPrice" | translate : { tier: 3 } }}</li>
        <li><strong>{{ "Template.PdfCatalogsComponent.label_column" | translate : { column: "N" } }}: </strong>{{ "Template.PdfCatalogsComponent.text_keyword" | translate }}</li>
        <li><strong>{{ "Template.PdfCatalogsComponent.label_column" | translate : { column: "R" } }}: </strong>{{ "Template.PdfCatalogsComponent.text_cmDescription4" | translate }}</li>
      </ul>
    </div>

    <div class="col">
      <strong class="d-block">{{ "Template.PdfCatalogsComponent.subHeader_secondSheet" | translate }}:</strong>
      <ul>
        <li>{{ "Template.PdfCatalogsComponent.text_secondSheetInfo" | translate }}</li>
      </ul>
    </div>

    <div class="col">
      <strong class="d-block">{{ "Template.PdfCatalogsComponent.subHeader_thirdSheet" | translate }}:</strong>
      <ul>
        <li>{{ "Template.PdfCatalogsComponent.text_thirdSheetInfo" | translate }}</li>
      </ul>
    </div>

    <div class="col">
      <strong class="d-block">{{ "Template.PdfCatalogsComponent.subHeader_miscellaneous" | translate }}:</strong>
      <ul>
        <li>{{ "Template.PdfCatalogsComponent.text_uniqueItemNumbers" | translate }}</li>
        <li>{{ "Template.PdfCatalogsComponent.text_xlsxFormat" | translate }}</li>
        <li>{{ "Template.PdfCatalogsComponent.text_itemOrder" | translate }}</li>
        <li>{{ "Template.PdfCatalogsComponent.text_coverPage" | translate }}</li>
        <li [innerHTML]="'Template.PdfCatalogsComponent.text_lineBreak' | translate"></li>
        <li [innerHTML]="'Template.PdfCatalogsComponent.text_titlePage' | translate"></li>
        <li [innerHTML]="'Template.PdfCatalogsComponent.text_imagePage' | translate"></li>
      </ul>
    </div>
  </div>
</div>
